export class NewDeviceDiscoveredNotification
{
    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);
        }
    }

    public BootVersion: number;
    public CommunicationPin: number;
    public ConnectedDeviceId: number;
    public DeviceType: number;
    public DeviceUid: string;
    public FirmwareVersion: number;
    public HardwareVersion: number;
    public IsDeviceOwned: boolean;
    public OwningOrganizationName: string;
    public OwningOrganizationPhone: string;
    public SecretDeviceId: string;
    public TypeCode: number;

    get SmartId(): number
    {
        return parseInt(this.DeviceUid.substring(10), 16);
    }

    get Name(): string{
        let name = this.SmartId.toString().length < 6 ? '0' + this.SmartId.toString() : this.SmartId.toString();
        return name;
    }
}
